import { IEndereco } from "app/types/IEndereco";
import globalMU from "globalMU";
import React, { memo, useCallback, useMemo } from "react";
import { AbaEnderecos } from "./AbaEnderecos";

export type AbaEnderecosContainerProps = {
    enderecos: IEndereco[];
    enderecosSelecionados: IEndereco[];
    cpfCnpj: string;
    onEditarEndereco: (ativar: boolean, endereco: IEndereco, index?: number) => void;
    onExcluirEnderecosTemporarios: (enderecos: IEndereco[]) => void;
    onToggleEnderecoSelecionado: (enderecos: IEndereco) => void;
    codigoIndicador: number
    tipoPessoa: string // 441453
}

export const AbaEnderecosContainer = memo((props: AbaEnderecosContainerProps) => {
    // useCallback nas lambdas inline — sem eles, AbaEnderecos.memo nunca funciona
    const handleIncluirEndereco = useCallback(() => {
        props.onEditarEndereco(true, null);
    }, [props.onEditarEndereco]);

    const handleEditarEndereco = useCallback((endereco: IEndereco) => {
        props.onEditarEndereco(true, endereco);
    }, [props.onEditarEndereco]);

    // Leitura de sessionStorage memoizada — não muda durante o ciclo de vida do componente
    const usuarioLogado = useMemo(() => globalMU.sessionStorage.getData('UsuarioLogado'), []);

    return (
        <AbaEnderecos
            tipoPessoa={props.tipoPessoa}
            exibitExcluirEndereco={props.codigoIndicador == null}
            enderecosSelecionados={props.enderecosSelecionados}
            habilitarExcluirEndereco={props.enderecosSelecionados?.length > 0}
            onToggleEnderecoSelecionado={props.onToggleEnderecoSelecionado}
            enderecos={props.enderecos}
            onIncluirEndereco={handleIncluirEndereco}
            onExcluirEndereco={props.onExcluirEnderecosTemporarios}
            onEditarEndereco={handleEditarEndereco}
            corSelecionado={usuarioLogado?.CorFundo}
            textoSelecionado={usuarioLogado?.CorTexto}
        />
    );
});
